import * as types from "./mutation_types"

export default {
    [types.RESET](state){
        Object.assign(state,{
            isLoading: false,
            created: null,
            showUser: false,
            user: "",
            isCreated:false,
            isSuccess: false,
            currentItem: null,
          
            modal: {
                title: "__",
                description: "__",
                type: "default",
                content: '',
    
    
            },
          
    
            showModal: false,
    
        }
    
        )
    },
    [types.SET_TOGGLE_LOADING](state){
        Object.assign(state,{isLoading:!state.isLoading})
    },
    [types.SET_SHOW_LOADING](state){
        Object.assign(state,{isLoading:true})
    },
    [types.SET_HIDE_LOADING](state){
        Object.assign(state,{isLoading:false})
    },
    [types.SET_TOGGLE_USER](state){
        Object.assign(state,{showUser:!state.showUser})
    },
    [types.SET_SHOW_USER](state){
        Object.assign(state,{showUser:true})
    },
    [types.SET_HIDE_USER](state){
        Object.assign(state,{showUser:false})
    },
    [types.SET_TOGGLE_MODAL](state){
        Object.assign(state,{showModal:!state.showModal})
    },
    [types.SET_SHOW_MODAL](state){
        Object.assign(state,{showModal:true})
    },
    [types.SET_HIDE_MODAL](state){
        Object.assign(state,{showModal:false})
    },
    [types.SET_MODAL](state,modal){
        Object.assign(state,{modal})
    },
    [types.SET_MODAL_TITLE](state,title){
        Object.assign(state,{modal:{...state.modal,title}})
    },
    [types.SET_MODAL_SUBTITLE](state,subtitle){
        Object.assign(state,{modal:{...state.modal,subtitle}})
    },
    [types.SET_MODAL_TYPE](state,type){
        Object.assign(state,{modal:{...state.modal,type}})
    },
    [types.SET_MODAL_CONTENT](state,content){
        Object.assign(state,{modal:{...state.modal,content}})
    },
    [types.SET_IS_SUCCESS](state){
        Object.assign(state,{isSuccess:true})
    },
    [types.SET_IS_ERROR](state){
        Object.assign(state,{isSuccess:false})
    },
    [types.SET_USER](state,user){
        Object.assign(state,{user})
    },
    [types.SET_CREATED](state,created){
        Object.assign(state,{created})
    },
    [types.SET_CURRENT_ITEM](state,currentItem){
        Object.assign(state,{currentItem})
    },
    [types.SET_IS_CREATED](state){
        Object.assign(state,{isCreated:true})
    },
    [types.SET_NOT_CREATED](state){
        Object.assign(state,{isCreated:false})
    },
}